(function() {
  const STORAGE_KEY = 'par-arielle-wishlist';

  function getWishlist() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function toggleWishlist(handle, btn) {
    let list = getWishlist();
    if (list.includes(handle)) {
      list = list.filter(h => h !== handle);
      btn.classList.remove('is-active');
    } else {
      list.push(handle);
      btn.classList.add('is-active');
    }
    saveWishlist(list);
    updateCounter();
  }

  function updateCounter() {
    const counter = document.getElementById('wishlist-count');
    if (counter) counter.textContent = getWishlist().length;
  }

  function addHeartToCard(card) {
    if (card.querySelector('.wishlist-heart')) return;
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    const handle = link.getAttribute('href').split('/products/')[1].split('?')[0].split('/')[0];

    const btn = document.createElement('button');
    btn.className = 'wishlist-heart';
    btn.innerHTML = '&#9825;';
    btn.setAttribute('aria-label', 'Ajouter aux favoris');
    if (isInWishlist(handle)) btn.classList.add('is-active');

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(handle, btn);
    });

    card.style.position = 'relative';
    card.appendChild(btn);
  }

  function initHearts() {
    document.querySelectorAll('.product-card, .card, [class*="product-item"]').forEach(addHeartToCard);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initHearts();
    updateCounter();
    const observer = new MutationObserver(initHearts);
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();